import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import OtpInput from 'react-otp-input';
import OtpTimer from 'otp-timer';
import styles from './forgotPassword/forgotpassword.module.scss';

const OTPForm = ({
  handleInputChange,
  blurredFields,
  errors,
  otp,
  handleLogin,
  cognitoCodeError,
  handleResendOTP,
  resendSuccess
}) => (
  <form name="ForgotPasswordForm" className={styles.form} onSubmit={handleLogin} noValidate>
    <div className={styles.otpForm}>
    <div className={styles.welcome}>
    <FormattedMessage id="authentication.login.welcome" defaultMessage="Airport Portal" />
    </div>
    <div className={styles.form_column}>
      <label htmlFor="email">
        <FormattedMessage id="authentication.login.otp" defaultMessage="Please enter code" />
        <div className={styles.otpField}>
          <OtpInput
            isInputNum
            containerStyle="otp-Outline"
            value={otp}
            onChange={e => handleInputChange('otp', e)}
            numInputs={4}
            isDisabled={false}
            className={styles.input_btn_style}
            inputStyle={styles.otp_input}
          />

        <div className={styles.resend}>
          <OtpTimer
            seconds={80}
            minutes={0}
            resend={handleResendOTP}
            textColor={'red'}
            buttonColor={'red'}
            background={'#fff'}
            ButtonText="Resend OTP"
          />
        </div>
        </div>
        {blurredFields.code && errors.codeEmpty ? (
          <small className={styles.error}>
            <FormattedMessage id="authentication.login.error.email_empty" defaultMessage="This field cannot be empty" />
          </small>
        ) : null}
        {
          cognitoCodeError ? (
          <small className={styles.error}>
            <FormattedMessage id="authentication.login.code.code_invalid" defaultMessage="You entered an invalid code. Please try again." />
          </small>
          ) : ''
        }
      </label>
    </div>
    <div className={styles.button_wrapper}>
      <button
        type="submit"
        className={styles.button}
      >
        <FormattedMessage id="authentication.login.login" defaultMessage="Login" />
      </button>
    </div>
      {
        resendSuccess ? (
        <small className={styles.success}>
          <FormattedMessage id="authentication.login.code.resend_success" defaultMessage="Code was resent successfully." />
        </small>
        ) : ''
      }
    </div>
  </form>
);


OTPForm.propTypes = {
  handleInputChange: PropTypes.func.isRequired,
  errors: PropTypes.shape({
    emailValid: PropTypes.bool
  }).isRequired,
  blurredFields: PropTypes.shape({
    emailValid: PropTypes.bool
  }).isRequired,
  handleInputBlurred: PropTypes.func.isRequired,
  handleLogin: PropTypes.func.isRequired
};

export default OTPForm;
